import React, { useEffect, useMemo } from "react";
import { useSnapshot } from "valtio";
import { wizardStore } from "../../stores/wizard";
import Selector from "../commons/Selector";
import QuickViewLayout from "./QuickViewLayout";
import { Size } from "./Size";
import { Steps } from "../../constants";
import { Design } from "./Design";
import ColorManager from "./commonComps/ColorManager";
import IndicationManager from "./commonComps/3DEmblem/IndicationManager";
import LeatherIndicationManager from "./commonComps/EmblemLeather/LeatherIndicationManager";
import Scrolling from "./commonComps/Scrolling";
import ColorDetails from "./commonComps/ColorDetails";
import { Step } from "../../types/wizard";

const stepsComponents: Record<string, React.ComponentType<any>> = {
  ProductSubtype: Selector,
  ProductType: Selector,
  Shape: Selector,
  FabricColor: Selector,
  FabricType: Selector,
  BackgroundPattern: Selector,
  BorderType: Selector,
  Backing: Selector,
  Layout: Selector,
  Combination: Selector,
  Scrolling,
  SizeStandard: Size,
  HolographicUpload: Design,
  DesignType: Design,
  HolographicColors: ColorDetails,
  ThreadColors: ColorDetails,
  BorderColor: ColorManager,
  SewingGuideColor: ColorManager,
  EmblemLeather: LeatherIndicationManager,
  Emblem3d: IndicationManager,
  EmblemPrintStitch: IndicationManager
};

const QuickViewWizard: React.FC = () => {
  const wizSnap = useSnapshot(wizardStore);
  console.log(wizardStore)

  useEffect(() => {
    const currentUrl = window.location.href;
    const newUrl = currentUrl.replace(/(#.*)$/, '#');
    window.history.replaceState({}, '', newUrl);
  }, []);

  const getColumnPosition = (stepId: string) => {
    switch (stepId) {
      // Selectors
      case Steps.ProductType:
      case Steps.ProductSubtype:
      case Steps.SizeStandard:
      case Steps.FabricType:
      case Steps.FabricColor:
      case Steps.Backing:
      case Steps.BorderType:
      case Steps.Shape:
      case Steps.Layout:
      case Steps.Scrolling:
      case Steps.BackgroundPattern:
      case Steps.BorderColor:
      case Steps.SewingGuideColor:
      case Steps.Combination:
        return 1;
      // Image uplaods
      case Steps.DesignType:
      case Steps.HolographicUpload:
        return 2;
      case Steps.Emblem3d:
      case Steps.EmblemLeather:
      case Steps.HolographicColors:
      case Steps.EmblemPrintStitch:
        return 4;
      default:
        return 3;
    }
  }

  const columns = useMemo(() => {
    return wizSnap.steps
      .map((step) => {
        const StepComponent = stepsComponents[step.id];
        const columnNumber = getColumnPosition(step.id);
        return StepComponent
          ? {
            column: columnNumber,
            step,
            content: (
              <StepComponent
                key={step.id}
                step={step}
                stepId={step?.id}
                column={columnNumber}
              />
            ),
          }
          : null;
      })
      .filter(Boolean);
  }, [wizSnap.steps]);

  return (
    <div className="flex h-full">
      <div className="w-full">
        <QuickViewLayout columns={columns as { column: number; step: Step; content: JSX.Element }[]} />
      </div>
    </div>
  );
};

export default QuickViewWizard;
